import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { spinnerStates } from '../../Globals/constants';
import Radium from 'radium';

class SmartSpinner extends Component {
  render() {
    return (
      <div>
        <i style={[{display: 'none'}, this.props.state===spinnerStates.LOADING && styles.show]} className="fa fa-spinner fa-spin fa-2x" />
        <i style={[{display: 'none'}, this.props.state===spinnerStates.FAILURE && styles.show]} className="fa fa-exclamation-triangle fa-2x" />
        <i style={[{display: 'none'}, this.props.state===spinnerStates.SUCCESS && styles.show]} className="fa fa-check fa-2x" />
      </div>
    );
  }
}

var styles = {
  show: {
    display: 'inline-block'
  }
}

SmartSpinner.propTypes = {
    state: PropTypes.string.isRequired
  };

const selectProps = state => {
  return {
    ...state.spinnerReducer
  };
}

export default connect(selectProps)(Radium(SmartSpinner));


// WEBPACK FOOTER //
// ./src/App/Common/SmartSpinner/index.jsx